import { Typography } from 'antd'
import { CartBlockedIcon } from '@modules/CustomIcons'
import { TableProps } from '@shared/Table'
import { t } from 'i18next'
import LimitTableUtilColumn from '../blocks/limitTableUtilColumn/LimitTableUtilColumn'
import LimitAdgustmentModal from '../blocks/regulationModal/limitAdjustment/LimitAdgustmentModal'
import CustomTooltip from '../../../../../components/Tooltip'
import { LIMIT_ATM, statusStyles } from './constantForLimits'
export const columns: () => TableProps<
  Omit<any, 'key'>
>['editColumns'] = () => {
  return {
    type: {
      title: (
        <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
          {t('businessCards.limitType')}
        </Typography.Text>
      ),
      width: 350,
      render(value, record, index) {
        return (
          <Typography.Text style={{ textWrap: 'wrap' }}>
            {t(`businessCards.${value}`)}
          </Typography.Text>
        )
      },
    },
    general: {
      title: (
        <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
          {t('businessCards.duration')}
        </Typography.Text>
      ),
      width: 100,
      ellipsis: true,
      render(value, record, index) {
        return t(`businessCards.${value.duration}`)
      },
    },
    count: {
      title: (
        <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
          {t('businessCards.limitforCount')}
        </Typography.Text>
      ),
      width:200,
      render: (value) => {
        const limitforCount = [
          { title: t('businessCards.appointed'), value: value?.designated },
          { title: t('businessCards.used'), value: value?.used },
          { title: t('businessCards.residue'), value: value?.residue },
        ]

        return value ? (
          <LimitTableUtilColumn data={limitforCount} />
        ) : (
          <Typography.Text
            style={{ fontSize: '14px', fontWeight: 500, color: '#000' }}
          >
            {t('businessCards.undefinedLimit')}
          </Typography.Text>
        )
      },
    },
    amount: {
      title: (
        <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
          {t('businessCards.limitforBalans')}
        </Typography.Text>
      ),
      width:200,
      render: (value) => {
        const limitforBalans = [
          {
            title: t('businessCards.appointed'),
            value: value?.designated + ' ' + value?.curr,
          },
          {
            title: t('businessCards.used'),
            value: value?.used + ' ' + value?.curr,
          },
          {
            title: t('businessCards.residue'),
            value: value?.residue + ' ' + value?.curr,
          },
        ]

        return value ? (
          <LimitTableUtilColumn data={limitforBalans} />
        ) : (
          <Typography.Text
            style={{ fontSize: '14px', fontWeight: 500, color: '#000' }}
          >
            {t('businessCards.undefinedLimit')}
          </Typography.Text>
        )
      },
    },
    date: {
      title: (
        <div style={{ display: 'flex', gap: 4 }}>
          <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
            {t('businessCards.dates')}
          </Typography.Text>
          <CustomTooltip
            placment="topRight"
            className="table-tooltip"
            title={t('businessCards.notificationInfo')}
          >
            <span>
              <CartBlockedIcon />
            </span>
          </CustomTooltip>
        </div>
      ),
      width: 220,
      render: (value) => {
        const dates = [
          { title: t('businessCards.status'), value: value?.dateStatus + 'd' },
          { title: t('businessCards.starting'), value: value?.fromDate },
          { title: t('businessCards.end'), value: value?.toDate },
        ]

        return value ? (
          <LimitTableUtilColumn data={dates} />
        ) : (
          <Typography.Text
            style={{ fontSize: '14px', fontWeight: 500, color: '#000' }}
          >
            {t('businessCards.undefinedLimit')}
          </Typography.Text>
        )
      },
    },
    status: {
      title: (
        <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
          {t('businessCards.status')}
        </Typography.Text>
      ),
      render(value, record, index) {
        const { background, color, text } =
          statusStyles[record.general.status as keyof typeof statusStyles]
        return (
          <Typography.Text
            style={{
              backgroundColor: background,
              color,
              padding: '2px 8px',
              borderRadius: '4px',
              display: 'inline-block',
              minWidth: '80px',
              textAlign: 'center',
            }}
          >
            {t(`businessCards.${text}`)}
          </Typography.Text>
        )
      },
    },
    settings: {
      title: (
        <Typography.Text style={{ color: '#000', fontWeight: 700 }}>
          {t('businessCards.regulations')}
        </Typography.Text>
      ),
      render(value, record, index) {
        return (
          record.type === LIMIT_ATM && <LimitAdgustmentModal record={record} />
        )
      },
    },
  }
}
